import React, { useState } from "react";
import "./PatientForm.css";
import countryCodes from "../data/country_code.json";
import { useNavigate } from "react-router-dom";

const PatientForm = () => {
  const navigate = useNavigate(); 


  const [form, setForm] = useState({
  name: "",
  dob: "",
  age: "",
  phone: "",
  email: "",
  country: "IN",
  countryCode: "+91"
});


  // Generic handler
  const handleChange = (e) => {
  setForm({ ...form, [e.target.name]: e.target.value });
};


  // DOB handler
  const handleDobChange = (e) => {
    setForm({
      ...form,
      dob: e.target.value
    });
  };

  // Age handler
  const handleAgeChange = (e) => {
    setForm({
      ...form,
      age: e.target.value
    });
  };



  // ✅ ONLY ONE SUBMIT HANDLER (FINAL)
  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch("http://localhost:5000/register", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        name: form.name,
        dob: form.dob,
        age: form.age,
        phone: form.countryCode + form.phone,
        email: form.email,
        abha_link: form.abha_link
      })
    });

    const result = await response.json();

    if (!response.ok) {
      alert("❌ Error: " + result.error);
      return;
    }

    alert("✅ Patient registered successfully!");
    navigate("/success"); // ✅ WORKS NOW

  } catch (error) {
    console.error("Network error:", error);
    alert("❌ Backend not reachable");
  }
};

  return (
    <div className="form-container">
      <h2>Patient Registration Form</h2>

      <form onSubmit={handleSubmit}>
        <label>Name:</label>
        <input
          type="text"
          name="name"
          value={form.name}
          onChange={handleChange}
          required
        />

        <label>Date of Birth:</label>
        <input
          type="date"
          name="dob"
          value={form.dob}
          onChange={handleDobChange}
          required
        />

        <label>Age:</label>
        <input
          type="number"
          name="age"
          value={form.age}
          onChange={handleAgeChange}
        />

        <label>Contact Number:</label>

<div className="phone-row" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
  
  {/* FLAG DISPLAY */}
  <img
    src={`/flags/${form.country.toLowerCase()}.png`}
    alt={form.country}
    width="24"
    height="16"
    style={{ borderRadius: "2px" }}
  />

  {/* COUNTRY CODE SELECT */}
  <select
    name="countryCode"
    value={form.countryCode}
    onChange={(e) => {
      const selected = countryCodes.find(
        (c) => c.dial_code === e.target.value
      );

      setForm({
        ...form,
        countryCode: selected.dial_code,
        country: selected.iso, // IMPORTANT
      });
    }}
  >
    {countryCodes.map((c) => (
      <option key={c.iso} value={c.dial_code}>
        {c.name} ({c.dial_code})
      </option>
    ))}
  </select>

  {/* PHONE INPUT */}
  <input
    type="tel"
    name="phone"
    placeholder="Enter phone number"
    value={form.phone}
    onChange={handleChange}
    required
  />
</div>

        <label>Email:</label>
        <input
          type="email"
          name="email"
          value={form.email}
          onChange={handleChange}
          required
        />

       

        <label>ABHA Link:</label>
        <input
  type="url"
  name="abha_link"
  value={form.abha_link}
  onChange={handleChange}
  placeholder="https://abha.abdm.gov.in/abha/v3/login"
  required
/>
    

        <button type="submit">Register Patient</button>
      </form>
    </div>
  );
};

export default PatientForm;
